import { Video } from "./video";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center" style={{paddingTop: 100}}>
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
          <p>
            Watch how it works...
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Video
                      // title={d.embedId}
                      embedId={d.embedId}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
